import DynamicLookup from './component/DynamicLookup';

export default DynamicLookup;
